var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "pc-build"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pc-build__text"
  }, [_c('h4', {
    staticClass: "pc-build__title"
  }, [_vm._v("Конфигуратор для сборки ПК")]), _vm._v(" "), _c('p', {
    staticClass: "pc-build__subtitle"
  }, [_vm._v("\n      Выберите компоненты, мы проверим их совместимость и соберем для вас\n      компьютер\n    ")]), _vm._v(" "), _c('GGLink', {
    staticClass: "pc-build__button cc-link cc-link_wu",
    attrs: {
      "to": "/pc-builder/"
    }
  }, [_c('button', {
    staticClass: "pc-build__button-el"
  }, [_vm._v("Собрать компьютер")])])], 1)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "pc-build__img-wrap"
  }, [_c('img', {
    staticClass: "pc-build__img",
    attrs: {
      "src": require("./asset/pc-build.jpg"),
      "srcset": require("./asset/pc-build@2x.jpg") + " 2x",
      "alt": "компьютер"
    }
  })]);
}]

export { render, staticRenderFns }